import { __decorate } from 'tslib';
import { Pipe, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
let TuiMapperPipe = class TuiMapperPipe {
    /**
     * Maps object to an arbitrary result through a mapper function
     *
     * @param value an item to transform
     * @param mapper a mapping function
     * @param args arbitrary number of additional arguments
     */
    transform(value, mapper, ...args) {
        return mapper(value, ...args);
    }
};
TuiMapperPipe.ɵfac = function TuiMapperPipe_Factory(t) { return new (t || TuiMapperPipe)(); };
TuiMapperPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "tuiMapper", type: TuiMapperPipe, pure: true });

let TuiMapperPipeModule = class TuiMapperPipeModule {
};
TuiMapperPipeModule.ɵfac = function TuiMapperPipeModule_Factory(t) { return new (t || TuiMapperPipeModule)(); };
TuiMapperPipeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiMapperPipeModule });
TuiMapperPipeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiMapperPipe, [{
        type: Pipe,
        args: [{ name: 'tuiMapper' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiMapperPipeModule, [{
        type: NgModule,
        args: [{
                exports: [TuiMapperPipe],
                declarations: [TuiMapperPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiMapperPipeModule, { declarations: [TuiMapperPipe], exports: [TuiMapperPipe] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiMapperPipe, TuiMapperPipeModule };

